module.exports = __webpack_public_path__ + "html/panoramic-form.template.html";